import {XauditModel} from '../../xaudit.model';

export class NotificationNeededItemDataModel extends XauditModel {
  dataNotificationNeededItemID: string;
  NotificationNeededID: string;
  enumNeededItemTypeID: string = '00000228-1000-0000-0000-000000000001'; // Currently we only have 1 type (Letter)
  enumLetterDeliveryToRoleID: string;
  enumLetterDeliveryEmailTypeID: string;
  ObjectID: string;
  Description: string;
  ToContactID: string;
  enumLetterDeliveryMethodID: string = '00000251-1000-0000-0000-000000000001'; // Currently we are only handling Email
  DeliveredOn: Date;
  DeliveredBy: string;
  Subject: string;

  // Front end use only
  contactType: string = '';
}
